
export default function Awards() {
  return (
    <section id="awards" className="py-16 sm:py-20 lg:py-24 px-4 sm:px-6 bg-[#0B0B0B]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-flex items-center gap-2 bg-amber-500/10 border border-amber-500/20 rounded-full px-5 py-2 mb-6">
            <i className="ri-award-line text-amber-400 text-sm"></i>
            <span className="text-amber-400 text-xs font-semibold uppercase tracking-widest">Recognition</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-6">
            Award-Winning Service
          </h2>
          <p className="text-base sm:text-lg text-gray-400 max-w-3xl mx-auto px-4 leading-relaxed">
            Recognized as the #1 Car Detailing Service in Wichita, The Auto Salon is trusted by vehicle owners who demand exceptional results, precision, and professionalism.
          </p>
        </div>

        <div className="flex justify-center">
          <div className="relative group">
            <div className="absolute -inset-1 bg-gradient-to-r from-amber-500/20 via-amber-400/10 to-amber-500/20 rounded-2xl blur-xl opacity-60 group-hover:opacity-100 transition-opacity duration-500"></div>
            <div className="relative bg-[#111827] border border-gray-800 rounded-2xl p-6 sm:p-10 max-w-md mx-auto">
              <div className="w-full h-auto flex items-center justify-center">
                <img
                  src="https://static.readdy.ai/image/ec7d44241e5d5731ab0de78142a46920/601c9d5e5426c93b0f29c850687bb7a4.png"
                  alt="The Auto Salon - Best of BusinessRate 2025 Award - #1 Car Detailing Service in Wichita KS"
                  title="The Auto Salon Award - Best Car Detailing Service Wichita"
                  className="w-full max-w-sm h-auto object-contain rounded-lg"
                />
              </div>
              <div className="mt-6 sm:mt-8 text-center">
                <div className="flex items-center justify-center gap-1 mb-3">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-amber-400 text-lg"></i>
                  ))}
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-white mb-2">
                  Best of BusinessRate 2025
                </h3>
                <p className="text-sm text-gray-400">
                  #1 Car Detailing Service &bull; Wichita, KS
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 sm:mt-16 grid grid-cols-2 sm:grid-cols-4 gap-6 sm:gap-8 max-w-3xl mx-auto">
          <div className="text-center">
            <div className="text-2xl sm:text-3xl font-bold text-white mb-1">500+</div>
            <div className="text-xs sm:text-sm text-gray-500">Vehicles Detailed</div>
          </div>
          <div className="text-center">
            <div className="text-2xl sm:text-3xl font-bold text-white mb-1">5.0</div>
            <div className="text-xs sm:text-sm text-gray-500">Star Rating</div>
          </div>
          <div className="text-center">
            <div className="text-2xl sm:text-3xl font-bold text-white mb-1">100%</div>
            <div className="text-xs sm:text-sm text-gray-500">Satisfaction</div>
          </div>
          <div className="text-center">
            <div className="text-2xl sm:text-3xl font-bold text-white mb-1">#1</div>
            <div className="text-xs sm:text-sm text-gray-500">In Wichita</div>
          </div>
        </div>
      </div>
    </section>
  );
}
